<template>
  <BaseIntersection
    :tag="tag"
    :callback="handleCallback"
    :options="{
      rootMargin: '-64px 0% 100% 0%',
    }"
  >
    <slot />
  </BaseIntersection>
</template>

<script>
import tag from '@/js/util/props/tag'

export default {
  props: {
    ...tag,
  },
  data() {
    return {
      element: undefined,
    }
  },
  mounted() {
    [this.element] = document.getElementsByTagName('body')
  },
  methods: {
    handleCallback({ isIntersecting }) {
      const { element } = this
      if (isIntersecting) {
        element.classList.remove('hero--invisible')
      } else {
        element.classList.add('hero--invisible')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/BaseIntersectionHero.vue